import { sessionAtom } from '@/atoms/app-atoms'
import { useAtomValue } from 'jotai'

export const useAuthContext = () => {
  return useAtomValue(sessionAtom)
}
